module.exports = __webpack_public_path__ + "static/media/spedizione.07296f23.png";